class AppStorage {
  key(key) {
    return key
  }
  getItem(key) {
    return localStorage.getItem(this.key(key))
  }
  setItem(key, value) {
    return localStorage.setItem(this.key(key), value)
  }
  checkItem(key) {
    return localStorage.getItem(this.key(key)) !== undefined
  }
}

export default new AppStorage()
